export const environment = {
  production: true,
  supabaseUrl: 'https://lvysjvlkaohnyqgmxrsm.supabase.co',
  supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx2eXNqdmxrYW9obnlxZ214cnNtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg1Mjg0MDYsImV4cCI6MjA3NDEwNDQwNn0.zqM4OgueUxJZl6MMPscdxWDSHdRuCpLHPoc0Btt_bf4',
  turnstileSiteKey: '0x4AAAAAAB5zoyrDrZzJm4Oe',
  metaPixelId: '1112263691117126',
};
